package com.kitco.metalynxscrapit.shared.domain.model

import kotlinx.serialization.Serializable

@Serializable
enum class Currency {
    USD, CAD, INR, AUD, EUR, GBP, JPY, CHF, ZAR, CNY, BRL, MXN, HKD, RUB
}
